module.exports = __webpack_public_path__ + "img/bg_avatar_male_80.a55794f6.png";